import {FC, SVGProps} from 'react';

export const SearchIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
	<svg viewBox="0 0 24 24" fill="none" aria-hidden {...props}>
		<path
			d="M10.5 18a7.5 7.5 0 1 1 0-15 7.5 7.5 0 0 1 0 15Zm8.1 2.1-3.9-3.9"
			stroke="currentColor"
			strokeWidth="1.75"
			strokeLinecap="round"
		/>
	</svg>
);
